/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelogcharts_Dailydesc2Inputs */

const id_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menampilkan perubahan harian untuk tahun lalu`)
};

const ms_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menunjukkan perubahan harian untuk tahun lepas`)
};

const da_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viser daglige ændringer for det seneste år`)
};

const de_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeigt tägliche Änderungen des letzten Jahres`)
};

const en_us2_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showing daily changes for the last year`)
};

const es_es2_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrando los cambios diarios del último año`)
};

const es_mx2_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrando los cambios diarios del último año`)
};

const fil_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ipinapakita ang araw-araw na pagbabago para sa nakaraang taon`)
};

const fr_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichage des modifications quotidiennes de l'année écoulée`)
};

const it_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra le modifiche giornaliere dell'ultimo anno`)
};

const hu_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napi változások megjelenítése az elmúlt évre`)
};

const nl_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toon dagelijkse wijzigingen voor het afgelopen jaar`)
};

const no_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viser daglige endringer for det siste året`)
};

const pl_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokazuje dzienne zmiany z ostatniego roku`)
};

const pt_br2_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showing daily changes for the last year`)
};

const pt_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mostrar alterações diárias do último ano`)
};

const ro_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se afișează modificările zilnice pentru ultimul an`)
};

const fi_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytetään päivittäiset muutokset viimeiseltä vuodelta`)
};

const sv_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visar dagliga ändringar för det senaste året`)
};

const vi_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiển thị thay đổi hàng ngày trong năm qua`)
};

const tr_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son bir yılın günlük değişiklikleri gösteriliyor`)
};

const cs_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazení denních změn za poslední rok`)
};

const bg_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показване на дневните промени за последната година`)
};

const ru_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показаны ежедневные изменения за последний год`)
};

const uk_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показано щоденні зміни за останній рік`)
};

const ar_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض التغييرات اليومية للسنة الماضية`)
};

const hi_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछले वर्ष के दैनिक परिवर्तन`)
};

const th_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แสดงการเปลี่ยนแปลงรายวันสำหรับปีที่ผ่านมา`)
};

const ja_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過去1年間の日別変更を表示`)
};

const zh_cn2_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showing daily changes for the last year`)
};

const zh_hant1_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showing daily changes for the last year`)
};

const ko_components_changelogcharts_dailydesc2 = /** @type {(inputs: Components_Changelogcharts_Dailydesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showing daily changes for the last year`)
};

/**
* | output |
* | --- |
* | "Showing daily changes for the last year" |
*
* @param {Components_Changelogcharts_Dailydesc2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelogcharts_dailydesc2 = /** @type {((inputs?: Components_Changelogcharts_Dailydesc2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelogcharts_Dailydesc2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelogcharts_dailydesc2(inputs)
	if (locale === "ms") return ms_components_changelogcharts_dailydesc2(inputs)
	if (locale === "da") return da_components_changelogcharts_dailydesc2(inputs)
	if (locale === "de") return de_components_changelogcharts_dailydesc2(inputs)
	if (locale === "en-US") return en_us2_components_changelogcharts_dailydesc2(inputs)
	if (locale === "es-ES") return es_es2_components_changelogcharts_dailydesc2(inputs)
	if (locale === "es-MX") return es_mx2_components_changelogcharts_dailydesc2(inputs)
	if (locale === "fil") return fil_components_changelogcharts_dailydesc2(inputs)
	if (locale === "fr") return fr_components_changelogcharts_dailydesc2(inputs)
	if (locale === "it") return it_components_changelogcharts_dailydesc2(inputs)
	if (locale === "hu") return hu_components_changelogcharts_dailydesc2(inputs)
	if (locale === "nl") return nl_components_changelogcharts_dailydesc2(inputs)
	if (locale === "no") return no_components_changelogcharts_dailydesc2(inputs)
	if (locale === "pl") return pl_components_changelogcharts_dailydesc2(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelogcharts_dailydesc2(inputs)
	if (locale === "pt") return pt_components_changelogcharts_dailydesc2(inputs)
	if (locale === "ro") return ro_components_changelogcharts_dailydesc2(inputs)
	if (locale === "fi") return fi_components_changelogcharts_dailydesc2(inputs)
	if (locale === "sv") return sv_components_changelogcharts_dailydesc2(inputs)
	if (locale === "vi") return vi_components_changelogcharts_dailydesc2(inputs)
	if (locale === "tr") return tr_components_changelogcharts_dailydesc2(inputs)
	if (locale === "cs") return cs_components_changelogcharts_dailydesc2(inputs)
	if (locale === "bg") return bg_components_changelogcharts_dailydesc2(inputs)
	if (locale === "ru") return ru_components_changelogcharts_dailydesc2(inputs)
	if (locale === "uk") return uk_components_changelogcharts_dailydesc2(inputs)
	if (locale === "ar") return ar_components_changelogcharts_dailydesc2(inputs)
	if (locale === "hi") return hi_components_changelogcharts_dailydesc2(inputs)
	if (locale === "th") return th_components_changelogcharts_dailydesc2(inputs)
	if (locale === "ja") return ja_components_changelogcharts_dailydesc2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelogcharts_dailydesc2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelogcharts_dailydesc2(inputs)
	return ko_components_changelogcharts_dailydesc2(inputs)
});
export { components_changelogcharts_dailydesc2 as "components.changelogCharts.dailyDesc" }